// src/components/app/proyectos/sensorica/ProjectOverview.tsx
'use client';

import { Box, Container, Typography, Grid, Paper, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface ProjectOverviewProps {
  overview: {
    title: string;
    subtitle: string;
    description: string;
    objectives: string[];
  };
}

export default function ProjectOverview({ overview }: ProjectOverviewProps) {
  return (
    <Box
      sx={{
        py: 8,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography
              variant="overline"
              sx={{
                color: 'rgba(255,255,255,0.9)',
                fontWeight: 700,
                letterSpacing: 2,
                mb: 1,
                display: 'block',
              }}
            >
              SENSÓRICA
            </Typography>
            <Typography variant="h2" component="h1" gutterBottom fontWeight={700}>
              {overview.title}
            </Typography>
            <Typography variant="h5" sx={{ mb: 3, opacity: 0.95, fontWeight: 300 }}>
              {overview.subtitle}
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8 }}>
              {overview.description}
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Paper
              elevation={8}
              sx={{
                p: 4,
                borderRadius: 3,
                background: 'rgba(255,255,255,0.95)',
                backdropFilter: 'blur(10px)',
              }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  color: 'primary.main',
                  fontWeight: 700,
                  mb: 3,
                }}
              >
                Objetivos del Proyecto
              </Typography>
              <List>
                {overview.objectives.map((objective, index) => (
                  <ListItem key={index} sx={{ py: 1.5 }}>
                    <ListItemIcon>
                      <CheckCircleIcon
                        sx={{
                          color: 'success.main',
                          fontSize: 28,
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={objective}
                      primaryTypographyProps={{
                        fontWeight: 500,
                        color: 'text.primary',
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}